var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"custom-tooltip"},[_c('button',{staticClass:"custom-tooltip-button",on:{"click":function($event){return _vm.copyText(_vm.value)},"mouseout":_vm.hideTooltip}},[_c('span',{ref:"tooltip",staticClass:"custom-tooltiptext"},[_vm._v("Хуулах")]),_c('i',{staticClass:"sr sr-file",attrs:{"id":"copy-button"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }